export const messages = {
    "wr-dashboard.search.input.hint": "Haku",
    "wr-dashboard.search.label.breadcrumb": "Hakutulokset",
    "wr-dashboard.search.message.empty": "Ei hakuasi vastaavia tuloksia",
    "wr-dashboard.side-bar.selected.title:plural": "{count} kohdetta valittu | {count} kohde valittu | {count} kohdetta valittu",
    "wr-dashboard.side-bar.backup-type.disk": "Levy",
    "wr-dashboard.side-bar.backup-type.file": "Tiedosto",
    "wr-dashboard.side-bar.backup-type.notarized": "Notarisoidut tiedostot ja kansiot",
    "wr-dashboard.side-bar.backup-type.exchange": "Sovellus – Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Sovellus – Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Sovellus – järjestelmän tila",
    "wr-dashboard.side-bar.backup-type.application": "Sovellus",
    "wr-dashboard.backups-table.column.name": "Nimi",
    "wr-dashboard.backups-table.column.size": "Koko",
    "wr-dashboard.backups-table.column.version": "Viimeisin versio",
    "wr-dashboard.backups-table.action.delete": "Poista",
    "wr-dashboard.backups-table.message.no-backups": "Pilvessä ei ole vielä varmuuskopioita",
    "wr-dashboard.backups-sidebar.label.size": "Koko",
    "wr-dashboard.backups-sidebar.label.type": "Tyyppi",
    "wr-dashboard.backups-sidebar.label.version": "Viimeisin versio",
    "wr-dashboard.backups-sidebar.label.created": "Luotu",
    "wr-dashboard.backups-sidebar.label.machine": "Kone",
    "wr-dashboard.backups-sidebar.label.owner": "Omistaja",
    "wr-dashboard.content-table.column.name": "Nimi",
    "wr-dashboard.content-table.column.versions": "Versiot",
    "wr-dashboard.content-table.column.volumes": "Taltiot",
    "wr-dashboard.content-table.column.path": "Polku",
    "wr-dashboard.content-table.column.size": "Koko",
    "wr-dashboard.content-table.column.version": "Viimeisin versio",
    "wr-dashboard.content-table.action.notary-verify": "Vahvista",
    "wr-dashboard.content-table.action.notary-get-crt": "Nouda varmenne",
    "wr-dashboard.content-table.action.asign": "Lähetä allekirjoitettavaksi",
    "wr-dashboard.content-table.action.versions": "Versiot",
    "wr-dashboard.content-table.action.restore": "Lataa",
    "wr-dashboard.content-table.label.size": "Koko",
    "wr-dashboard.content-table.label.created": "Luotu",
    "wr-dashboard.content-table.label.modified": "Muokattu",
    "wr-dashboard.content-table.message.empty-folder": "Kansio on tyhjä",
    "wr-dashboard.password-dialog-box.title.backup": "Salattu varmuuskopio",
    "wr-dashboard.password-dialog-box.title.archive": "Salattu arkisto",
    "wr-dashboard.password-dialog-box.message.backup": "Anna varmuuskopion {displayName} salasana",
    "wr-dashboard.password-dialog-box.message.archive": "Anna arkiston {displayName} salasana",
    "wr-dashboard.password-dialog-box.hint.password": "Salasana",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Salasana on väärä",
    "wr-dashboard.form.button.open": "Avaa",
    "wr-dashboard.form.button.close": "Sulje",
    "wr-dashboard.form.button.cancel": "Peruuta",
    "wr-dashboard.form.button.continue": "Jatka",
    "wr-dashboard.form.button.proceed": "Jatka",
    "wr-dashboard.form.button.delete": "Poista",
    "wr-dashboard.form.button.done": "Valmis",
    "wr-dashboard.form.button.retry": "Yritä uudelleen",
    "wr-dashboard.notary.verify.view.status.downloading": "Ladataan palvelusta...",
    "wr-dashboard.notary.verify.view.status.validating": "Vahvistetaan...",
    "wr-dashboard.notary.verify.view.status.pending": "Odotetaan varmennetta...",
    "wr-dashboard.notary.verify.view.status.fail": "Varmenneristiriita...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Nouda varmenne",
    "wr-dashboard.notary.verify.view.file-info.name": "NIMI",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "ALLEKIRJOITTANUT",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "VARMUUSKOPIOINTIPÄIVÄ",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "NOTARISOINTIPÄIVÄ",
    "wr-dashboard.notary.verify.view.button.cancel": "Peruuta",
    "wr-dashboard.notary.verify.view.button.done": "Valmis",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Ei-tuettu selainversio",
    "wr-dashboard.versions-dialog-box.title": "Tiedoston {fileName} versiot",
    "wr-dashboard.asign-dialog-box.title": "Lähetä allekirjoitettavaksi",
    "wr-dashboard.asign-dialog-box.message": "Tiedostoversio on jaettu, mutta kukaan ei voi tarkastella sitä ilman tiedostoon johtavaa linkkiä. Siirry ASigniin lisäämään allekirjoittajia ja jakamaan linkkiä.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Näytä tiedoston tiedot",
    "wr-dashboard.page-not-found.title": "Sivua ei löydy",
    "wr-dashboard.page-not-found.message.main": "Etsimääsi sivua ei löytynyt.",
    "wr-dashboard.page-not-found.message.description": "Linkki saattaa olla vanhentunut tai olet ehkä kirjoittanut osoitteen väärin.",
    "wr-dashboard.page-not-found.message.error": "Virhekoodi: 404",
    "wr-dashboard.server-error.title": "Palvelin ei ole käytettävissä",
    "wr-dashboard.server-error.message": "Palvelin ei ole juuri nyt käytettävissä. Yritä myöhemmin uudelleen.",
    "wr-dashboard.server-error.message.error": "Virhekoodi: 500",
    "wr-dashboard.account-menu.action.sign-out": "Kirjaudu ulos",
    "wr-dashboard.breadcrumb.item.machines": "Koneet",
    "wr-dashboard.breadcrumb.item.failed-backups": "Epäonnistuneet varmuuskopiot",
    "wr-dashboard.machines-table.column.name": "Nimi",
    "wr-dashboard.machines-table.column.size": "Koko",
    "wr-dashboard.machines-table.message.no-machines": "Pilvessä ei ole vielä koneita",
    "wr-dashboard.incomplete-backups.message.status:plural": "Sinulla on {count} epäonnistunutta tai epätäydellistä varmuuskopiota, jotka vievät tilaa {size} | Sinulla on {count} epäonnistunut tai epätäydellinen varmuuskopio, joka vie tilaa {size} | Sinulla on {count} epäonnistunutta tai epätäydellistä varmuuskopiota, jotka vievät tilaa {size}",
    "wr-dashboard.incomplete-backups.button.view": "Näytä varmuuskopiot",
    "wr-dashboard.incomplete-backups.button.delete": "Poista varmuuskopiot",
    "wr-dashboard.machines-table.message.space-used:plural": "Varmuuskopioiden tallennustilan kokonaiskäyttö {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Poista arkistot",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Poista epätäydelliset arkistot",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Poista kaikki epätäydelliset arkistot",
    "wr-dashboard.delete-archive.message": "Haluatko varmasti poistaa valitut arkistot pysyvästi kaikista sijainneista? Kaikki tiedot poistetaan, eikä niitä voi palauttaa.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Varmenne odottaa",
    "wr-dashboard.certificate-pending-dialog-box.message": "Yritä uudelleen muutaman minuutin kuluttua.",
    "wr-dashboard.form.button.ok": "OK"
};
